import React from 'react'
import {App} from 'antd'
import {DeleteOutlined,} from '@ant-design/icons';
function ModalDel(props) {
    const {modal} = App.useApp()
        return (
        <a onClick={() => {
            modal.confirm({
                title: '确定删除吗?',
                content: '删除后不能恢复',
                okText: '确认',
                okType: 'danger',
                cancelText: '取消',
                onOk() {props.onOk()},
                onCancel() {
                    // console.log('Cancel');
                },
            }); 
        }}><DeleteOutlined /> 删除</a>
    )
}

export default ModalDel